import * as angular from 'angular';
import * as _ from 'lodash';
import template from './adminDashboard.tpl.html';
import {NavigationModel, Plant} from "../../models/navigation";
import {apsEnums} from "../../shared/dto/aps.enums";
import {States} from "../../shared/config/constant.module";
import NavigationServiceName, {NavigationService} from "../../services/navigation/navigation.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import {StateParams} from "../../common";

let requires = [NavigationServiceName, LoaderServiceName];

class AdminDashboardCtrl {
  plants: Plant[];
  packEfficiency: apsEnums.WellKnownCheckType;

  private navigation: NavigationModel;
  private $state: angular.ui.IStateService;
  private $stateParams: StateParams;

  constructor(navigationService: NavigationService,
              loaderService: LoaderService,
              $state: angular.ui.IStateService,
              $stateParams: StateParams) {
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.packEfficiency = apsEnums.WellKnownCheckType.ShopPackEfficiency;
    var loadNavPromise = navigationService.getNavigation().then(navModel => {
      this.navigation = navModel;
      this.plants = navModel.plants().filter(x => !x.isDisabled);
    });
    loaderService.loadingPromise(loadNavPromise);
  }

  goToPlant(plant: Plant) {
    this.navigation.selectPlant(plant);
    this.$state.go(States.PLANT_DASHBOARD, {
      plantId: plant.id,
      shopId: _.first(plant.shops).id,
      userId: this.$stateParams.userId
    });
  }
}

export default angular.module('aps.controller.adminDashboard', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.ADMIN_DASHBOARD,
      url: '/overview/dashboard',
      controller: 'AdminDashboardCtrl as vm',
      template: template,
      data: { 
        pageTitle: 'Company Snapshot',
        v2Uri: 'aps/dashboard/company/plant-overview'
      },
      
    });
  })
  .controller('AdminDashboardCtrl', AdminDashboardCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/dashboard/adminDashboard.controller.ts